import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQS = [
  {
    q: "Hoe weet WanneerKaartverkoop.nl wanneer een kaartverkoop start?",
    a: "Wij verzamelen verkoopdata rechtstreeks van organisatoren en officiële event-websites. Onze automatische scraper controleert die bronnen dagelijks en onze redactie werkt data handmatig bij. Zo zie je altijd de meest actuele startdatum en -tijd.",
  },
  {
    q: "Hoe ontvang ik een herinnering voor een event?",
    a: "Klik bij een event op 'Herinner mij' of 'Stel alert in' en laat je e-mailadres of WhatsApp-nummer achter. Zodra de kaartverkoop start, sturen wij je direct een gratis seintje. Je kunt de start van de verkoop ook in je Google- of Apple-agenda zetten.",
  },
  {
    q: "Is WanneerKaartverkoop.nl gratis te gebruiken?",
    a: "Ja, volledig gratis. Zoeken, countdowns, agenda-koppelingen en herinneringen per e-mail of WhatsApp kosten niets. Wij verkopen zelf geen tickets; de aankoop loopt altijd via het officiële verkoopkanaal van de organisator.",
  },
  {
    q: "Hoe kan ik mijn eigen event aanmelden op het platform?",
    a: "Klik op 'Meld je kaartverkoop aan' onderaan de homepage of stuur een bericht via de contactpagina. Vul de eventgegevens en de start van je kaartverkoop in; wij nemen je aanmelding meestal binnen twee werkdagen in behandeling. Aanmelden is gratis.",
  },
];

export const FAQ = () => (
  <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24" data-testid="faq-section">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">FAQ</p>
      <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
        Veelgestelde vragen
      </h2>
    </motion.div>
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.15 }}
      className="mt-8"
    >
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="rounded-2xl border border-white/[0.08] bg-[#12121C] px-5 transition-colors data-[state=open]:border-volt/30"
          >
            <AccordionTrigger
              data-testid={`faq-question-${i}`}
              className="py-5 text-left font-display text-base font-bold tracking-tight text-white hover:text-volt hover:no-underline"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-400">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  </section>
);
